import { isBoolean, MUST_BE_BOOLEAN, validateParam } from "../core/Helpers";
import { validateGooglePayBillingAddressFormat } from "./GooglePayBillingAddressFormat";
export var validateGooglePayBillingAddressParameters = function (googlePayBillingAddressParameters) {
    var errorMessage = [];
    // format: GooglePayBillingAddressFormat
    var validationResult = validateGooglePayBillingAddressFormat(googlePayBillingAddressParameters.format);
    var format = validateParam(googlePayBillingAddressParameters.format, "format", validationResult === null, true, " ".concat(validationResult ? validationResult : ""));
    format && errorMessage.push(format);
    // phoneNumberRequired?: boolean
    var billingAddressRequired = validateParam(googlePayBillingAddressParameters.phoneNumberRequired, "phoneNumberRequired", isBoolean(googlePayBillingAddressParameters.phoneNumberRequired), false, MUST_BE_BOOLEAN);
    billingAddressRequired && errorMessage.push(billingAddressRequired);
    return errorMessage.length === 0 ? null : errorMessage.join(", ");
};
